import { axios, getConfigs, IRequestConfig } from './api'

export interface CommentDto {
  id: number
  orderId: number
  content: string
  createdBy: number
  createdByFullName?: string
  createdAt: Date
}

export interface CreateCommentDto {
  orderId: number
  content: string
}

export interface UpdateCommentDto {
  content: string
}

export class CommentsService {
  private static readonly endpoint = 'comments'

  /**
   * Create a new comment for an order
   */
  static create(dto: CreateCommentDto): Promise<CommentDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        this.endpoint,
        {},
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }

  /**
   * Update an existing comment
   */
  static update(id: number, dto: UpdateCommentDto): Promise<CommentDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'patch',
        'application/json',
        `${this.endpoint}/${id}`,
        {},
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }

  /**
   * Delete a comment by ID
   */
  static delete(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        `${this.endpoint}/${id}`,
        {},
      )
      axios(configs, resolve, reject)
    })
  }

  /**
   * Get all comments for a specific order
   */
  static getByOrderId(orderId: number): Promise<CommentDto[]> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        this.endpoint,
        {},
      )
      configs.params = {
        orderId,
      }
      axios(configs, resolve, reject)
    })
  }
}
